// extracted by mini-css-extract-plugin
module.exports = {"pure_antd_loading":"index_pure_antd_loading__HaKE-"};